module.exports = __webpack_public_path__ + "static/img/Logo_Pamcard_Branco_seta_amarela.40e45a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/common/hotsite/components/header/Logo_Pamcard_Branco_seta_amarela.svg
// module id = 1828
// module chunks = 1